export default "__VITE_ASSET__tf3TJK2Y__"